import React from 'react';
import HiddenLoader from '@fuww/components/src/HiddenLoader';

const HiddenLoading = () => <HiddenLoader />;

export default HiddenLoading;
